const initAnnouncementBar = () => {
    let announcementEle = document.querySelector('.announcebar-wrapper');
    console.log("Announcement Element:", announcementEle);
    if (!announcementEle) return; 
    
    let swiperOptions = {};
    try {
      swiperOptions = JSON.parse(announcementEle.dataset.sliderOptions || '{}');
    } catch (err) {
      console.warn('Announcement bar: invalid slider options JSON, falling back to defaults', err, announcementEle.dataset.sliderOptions); 
      swiperOptions = {};
    }

    swiperOptions.slidesPerView = 1;

    let swiper = new Swiper(announcementEle, swiperOptions);
    console.log("Swiper Instance:", swiper, 'options:', swiperOptions);
    // announcementEle.addEventListener('mouseover', () => {
    //   if (swiper.autoplay) { 
    //     swiper.autoplay.stop();
    //   }
    // });
    
    // announcementEle.addEventListener('mouseleave', () => {
    //   if (swiper.autoplay) {
    //     swiper.autoplay.start();
    //   }
    // });
  
    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        let targetEle = e.target;
        if (targetEle.dataset.swiperSlideIndex) {
          let sliderIndex = parseInt(targetEle.dataset.swiperSlideIndex);
          swiper.slideTo(sliderIndex);
          if (swiper.autoplay) {
            swiper.autoplay.stop();
          }
        }
      });
      
      const customizationEvents = [
        'shopify:inspector:activate',
        'shopify:inspector:deactivate',
        'shopify:section:load',
        'shopify:block:deselect',
        'shopify:section:reorder',
        'shopify:section:select',
        'shopify:section:deselect'
      ];
  
      customizationEvents.forEach(event => {
        document.addEventListener(event, () => {
          if (swiper) {
            swiper.destroy(true, true);
          }
          swiper = new Swiper(announcementEle, swiperOptions);
        });
      });
    }
};
  
window.addEventListener('DOMContentLoaded', () => {
  initAnnouncementBar();
});